'use strict';

var cov_1r8nc80a83 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.executions.factory.js',
        hash = '5577fdd87a124b6a01a92f64d756e310621ca75d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.executions.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 48
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 33,
                    column: 20
                },
                end: {
                    line: 33,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 27,
                        column: 24
                    },
                    end: {
                        line: 27,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 41
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 27
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 32,
                        column: 24
                    },
                    end: {
                        line: 32,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 41
                    },
                    end: {
                        line: 34,
                        column: 17
                    }
                },
                line: 32
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1r8nc80a83.s[0]++;
(function () {
    'use strict';

    cov_1r8nc80a83.f[0]++;
    cov_1r8nc80a83.s[1]++;
    angular.module('app').factory('ExecutionsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1r8nc80a83.f[1]++;
        cov_1r8nc80a83.s[2]++;


        return restmod.model('/executions').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 10
                }
            },
            $config: {
                contains: {
                    task: {
                        type: 'belongsTo',
                        table: 'TasksTable',
                        foreignKey: 'task'
                    }
                }
            },
            start: {
                decode: function decode(value) {
                    cov_1r8nc80a83.f[2]++;
                    cov_1r8nc80a83.s[3]++;

                    return new Date(value);
                }
            },
            end: {
                decode: function decode(value) {
                    cov_1r8nc80a83.f[3]++;
                    cov_1r8nc80a83.s[4]++;

                    return new Date(value);
                }
            }
        });
    }
})();